import styled from 'styled-components';

export const StyledChartWrapper = styled.div`
  position: relative;
  height: 100%;
`;
